import { jwtConfig,itsmeConfig, EN_translation, FR_translation, NL_translation } from "../../config";
//import jwtDecode from 'jwt-decode';

class JwtAuth {
  login = async (userInfo) => {
    // console.log("User Ifoooo " + userInfo.userName);
    if (!userInfo.userName || !userInfo.password) {
      return { error: "Please fill in the username or password" };
    }
    if (userInfo.userName === "" || userInfo.password === "") {
      return { error: "Please fill in the username or password" };
    }
    // console.log("jwtConfig asd", jwtConfig.userLogin);
    return await fetch(jwtConfig.userLogin, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userInfo),
    })
      .then((response) => response.json())
      .then((res) => {
        // if(res.success === false){
        //   let sendData = res.message;
        //   localStorage.setItem('errorMessage', sendData);
        //   window.location.href = '/404';
        // }
        // console.log('res', res)
        //const result = {};
        // console.log("res api", res);
        return res;
      })
      .catch((error) => ({ error }));
  };

  itsme = async (userInfo) => {
    return await fetch(itsmeConfig.userInfo, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userInfo),
    })
      .then((response) => response.json())
      .then((res) => {
        if(res.success === false){
          let sendData = res.message;
          if ([EN_translation.minorItsmeLoginErr, FR_translation.minorItsmeLoginErr, NL_translation.minorItsmeLoginErr].includes(sendData)) {
            localStorage.setItem('itsmeLoginError', sendData);
            window.location.href = '/login';
          } else {
            localStorage.setItem('errorMessage', sendData);
            window.location.href = '/404';
          }
        }
        //const result = {};
        // console.log("res api", res);
        return res;
      })
      .catch((error) => ({ error }));
  };

  firstLogin = async (userInfo) => {
    // console.log("User Ifoooo " ,userInfo);
    if (!userInfo.userName || !userInfo.newPass || !userInfo.confirmPass) {
      return { error: "Please fill in the username or password" };
    }
     return await fetch(jwtConfig.firstLogin, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userInfo),
    })
      .then((response) => response.json())
      .then((res) => {
        //const result = {};
        // localStorage.setItem('rememberMe', res.data.rememberMe);
        // console.log("res api", res);
        return res;
      })
      .catch((error) => ({ error }));
  };
}

export default new JwtAuth();
